<template>
  <div class="details">
    <div style="position: relative">
      <img
        src="../../assets/detail-banner.jpg"
        style="height: 200px; width: 100%"
        alt="banner"
      />
      <h1 class="banner-text">
        {{ mouldInfo.name }}
      </h1>
    </div>
    <el-row>
      <el-col
        :xs="{ span: 20, offset: 1 }"
        :sm="{ span: 20, offset: 1 }"
        :md="{ span: 20, offset: 1 }"
        :lg="{ span: 20, offset: 1 }"
      >
        <el-breadcrumb
          separator-class="el-icon-arrow-right"
          class="breadcrumb"
          itemscope
          itemtype="https://schema.org/BreadcrumbList"
        >
          <el-breadcrumb-item
            v-if="breadcrumb.length > 0"
            itemprop="itemListElement"
            :to="{ path: '/' }"
            >Home</el-breadcrumb-item
          >
          <el-breadcrumb-item
            v-for="item in breadcrumb"
            :key="item.id"
            itemprop="itemListElement"
            :to="{ path: item.path }"
            >{{ item.name }}</el-breadcrumb-item
          >
          <el-breadcrumb-item
            v-if="breadcrumb.length > 0"
            itemprop="itemListElement"
            >{{ mouldInfo.name }}</el-breadcrumb-item
          >
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-col
        :xs="{ span: 20, offset: 2 }"
        :sm="{ span: 20, offset: 2 }"
        :md="{ span: 18, offset: 3 }"
        :lg="{ span: 16, offset: 4 }"
      >
        <el-row
          v-loading="listLoad"
          class="detail-row"
          type="flex"
          justify="space-around"
          :gutter="40"
          style="margin-bottom: 1rem"
        >
          <el-col :md="10">
            <div style="border: 1px solid #eee">
              <el-carousel
                v-if="mouldInfo && mouldInfo.attachList"
                height="20vw"
                indicator-position="none"
              >
                <el-carousel-item
                  v-for="(item, index) in mouldInfo.attachList"
                  :key="index"
                >
                  <img :src="item.fileUrl" class="carimg" />
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-col>
          <el-col :md="14">
            <h3 class="detail-title">
              {{ mouldInfo.name }}
            </h3>
            <h4 class="introduce" style="padding: 0; margin: 0">
              {{ mouldInfo.introduce }}
            </h4>
            <p style="padding-bottom: 0; margin-bottom: 0">
              {{ details }}
            </p>
            <div>
              <el-button
                v-if="!isMobile"
                type="primary"
                class="quotation-btn"
                @click="getQuotation"
              >
                Get Quotations
              </el-button>
            </div>
          </el-col>
        </el-row>

        <el-row
          v-if="
            mouldInfo.internationalProductsParameterList &&
            mouldInfo.internationalProductsParameterList.length > 0
          "
          class="detail-table"
        >
          <template
            v-for="item in mouldInfo.internationalProductsParameterList"
          >
            <el-col
              :key="item.parameterKey"
              class="detail-label"
              :xs="10"
              :sm="10"
              :md="3"
              :lg="3"
            >
              <auto-tool-tip :content="item.parameterKey" placement="top">
                <span>{{ item.parameterKey }}</span>
              </auto-tool-tip>
            </el-col>
            <el-col
              :key="item.value"
              class="detail-value"
              :xs="14"
              :sm="14"
              :md="5"
              :lg="5"
            >
              <auto-tool-tip :content="item.parameterValue" placement="top">
                <span>{{ item.parameterValue }}</span>
              </auto-tool-tip>
            </el-col>
          </template>
        </el-row>
      </el-col>
    </el-row>

    <el-row class="inquiry-form">
      <el-col
        :xs="{ span: 20, offset: 2 }"
        :sm="{ span: 20, offset: 2 }"
        :md="{ span: 18, offset: 3 }"
        :lg="{ span: 16, offset: 4 }"
      >
        <h2 class="title">Product Inquiry</h2>
        <p class="desc">
          Email us if you are interested in ts communication fiber optic
          products and solutions. We would be happy to answer your questions.
        </p>
        <el-col :xs="24" :sm="12" :md="12" :lg="12">
          <el-input v-model="quotation.name" placeholder="*Name"></el-input>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12">
          <el-input v-model="quotation.email" placeholder="*Email"></el-input>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12">
          <el-input
            v-model="quotation.businessPhoneNumber"
            placeholder="*Phone"
          ></el-input>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12">
          <el-input
            v-model="quotation.estimatedOrderQuantity"
            placeholder="Order Quantity"
          ></el-input>
        </el-col>
        <el-col :span="24">
          <el-input
            v-model="quotation.requirements"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="Content"
          ></el-input>
        </el-col>
        <el-col :span="24">
          <el-button
            type="primary"
            :loading="submmiting"
            class="submit-btn"
            @click="submmit"
          >
            submit
          </el-button>
        </el-col>
      </el-col>
    </el-row>

    <el-row class="more-moulds">
      <el-col
        :xs="{ span: 20, offset: 2 }"
        :sm="{ span: 20, offset: 2 }"
        :md="{ span: 20, offset: 2 }"
        :lg="{ span: 20, offset: 2 }"
      >
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
          "
        >
          <h1 class="title" span="">Recommended Products</h1>
          <div>
            <el-button
              type="primary"
              icon="el-icon-refresh-right"
              circle
              @click.native="
                () => {
                  getProductsByCategory();
                }
              "
            ></el-button>
          </div>
        </div>
        <MouldExhibition :moulds="moreMoulds" :type="type" :loose="true" />

        <div
          v-if="categoryDetail && categoryDetail.moreAbout"
          class="moreAbout"
          style="margin-bottom: 20px"
        >
          <template v-for="(item, index) in categoryDetail.moreAbout">
            <div :key="index">
              <h2>
                {{ item.title }}
              </h2>
              <div :key="index">
                <p
                  v-for="(docItem, docIndex) in item.documents"
                  :key="docIndex"
                  v-html="docItem"
                ></p>
              </div>
            </div>
          </template>
        </div>

        <div v-if="categoryDetail && categoryDetail.qas" class="qa">
          <h2 class="title">
            {{ breadcrumb[breadcrumb.length - 1].name }} FAQ
          </h2>
          <template v-for="(item, index) in categoryDetail.qas">
            <div :key="index">
              <h3>
                {{ item.q }}
              </h3>
              <p style="white-space: pre-line">
                {{ item.a }}
              </p>
            </div>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import detailsData from "@/views/ProductDetail/detailsData";
import { mouldCategories } from "../../static/data";
import "./_Details.scss";
import { palFormUrl } from "../../config/appConfig";
import { customFetch } from "../../utils/api";
import { getRandomArr } from "../../utils/tool";
import MouldExhibition from "@/components/ProductsItem/MouldExhibition";
import { retryTips } from "../../static/staticText";
import AutoToolTip from "../../components/AutoTooltip/AutoTooltip";
export default {
  name: "ProductDetail",
  components: { AutoToolTip, MouldExhibition },
  props: {},
  data() {
    return {
      categoryOptions: [],
      propsOption: {
        value: "id",
        label: "name",
        children: "internationalProductsCategoryList",
        expandTrigger: "hover",
        checkStrictly: true,
      },
      mouldCategories,
      progress: 0,
      type: 0,
      numPages: 1,
      loadedPages: 1,
      targetMould: {},
      images: [],
      childMould: null,
      parentMould: {},
      mouldInfo: {
        name: "",
        categoryName: "",
        attachList: [],
        introduce: "",
      },
      moreMoulds: [],
      detailInfo: [],
      mouldCategoryObj: "",
      listLoad: false,
      submmiting: false,
      quotation: {},
      breadcrumb: [],
      ancestors: [],
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    details() {
      return (
        detailsData[this.$route.params.id] &&
        detailsData[this.$route.params.id].details
      );
    },
    categoryDetail() {
      return detailsData[this.$route.params.id] || null;
    },
  },
  async created() {
    const { categoryParentId, categoryId } = await this.getDetail(
      this.$route.params.id
    );
    await this.getBreadcrumb(categoryId);
    this.getProductsByCategory();
    this.getAllCategory();
  },
  async beforeRouteUpdate(to, from, next) {
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: "smooth",
    });
    next();
    await this.getDetail(to.params.id);
    await this.getBreadcrumb(to.params.id);
    this.getProductsByCategory();
  },
  methods: {
    getBreadcrumb(id) {
      return new Promise((resolve, reject) => {
        customFetch(
          `${palFormUrl}/international/getInternationalProductsCategoryListById?id=${id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          },
          (res) => {
            this.ancestors = res.result;
            this.breadcrumb = res.result.map((item) => {
              return {
                name: item.name,
                path: `/products-list/${item.name
                  .split(" ")
                  .map((it) => it.toLowerCase())
                  .join("-")}/${item.id}`,
              };
            });
            resolve();

            const breadcrumb = document.getElementById("breadcrumb");
            const breadcrumbData = {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
            };

            breadcrumbData.itemListElement = res.result.map((item, index) => {
              return {
                "@type": "ListItem",
                position: index,
                item: {
                  "@id": `https://hic.cosmoplat.com/products-list/${item.name
                    .split(" ")
                    .map((it) => it.toLowerCase())
                    .join("-")}/${item.id}`,
                  name: item.name,
                },
              };
            });

            breadcrumb.innerText = JSON.stringify(breadcrumbData);
          },
          () => {
            reject();
          }
        );
      });
    },
    getDetail(id) {
      return new Promise((resolve, reject) => {
        this.listLoad = true;
        customFetch(
          `${palFormUrl}/international/getProductDetail`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              id: id,
            }),
          },
          (res) => {
            document.title =
              res.result.title ||
              "HiMo Industry: Mold Manufacturer In China, Custom Moulding & 3D Printing Service Company";
            if (res.result.keywords) {
              document
                .querySelector("meta[name='keywords']")
                .setAttribute("content", res.result.keywords);
            }
            if (res.result.description) {
              document
                .querySelector("meta[name='description']")
                .setAttribute("content", res.result.description);
            }
            this.$nextTick(() => {
              this.listLoad = false;
              this.mouldInfo = res.result;
            });

            const structureScript = document.getElementById("structureData");
            structureScript.type = "application/ld+json";
            const structureData = {
              "@context": "https://schema.org",
              "@type": "Product",
              image: res.result.attachList && res.result.attachList[0].fileUrl,
              name: res.result.name,
              description: res.result.description,
            };

            structureScript.innerText = JSON.stringify(structureData);

            resolve({
              categoryParentId: res.result.categoryParentId,
              categoryId: res.result.categoryId,
            });
          },
          () => {
            this.listLoad = false;
            reject();
          }
        );
      });
    },
    goBack() {
      console.log("返回");
      this.$router.go(-1);
    },
    getQuotation: function () {
      xn("openChat", "kf_10024_template_21");
    },

    getProductsByCategory(categoryId) {
      this.moreMoulds = [];
      customFetch(
        `${palFormUrl}/international/getInternationalProductsByCategoryId`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            categoryId:
              categoryId || this.ancestors[this.ancestors.length - 1].id,
            pageNum: 1,
            pageSize: 100,
          }),
        },
        (res) => {
          if (res.result.list.length >= 4) {
            this.moreMoulds = getRandomArr(res.result.list, 4);
          } else {
            const categoryIndex = this.ancestors.findIndex(
              (item) =>
                item.id ===
                (categoryId || this.ancestors[this.ancestors.length - 1].id)
            );
            const targetIndex = categoryIndex > -1 ? categoryIndex - 1 : -1;
            const newCategoryId =
              targetIndex > -1 ? this.ancestors[targetIndex].id : 0;
            this.getProductsByCategory(newCategoryId);
          }
        },
        () => {}
      );
    },

    submmit() {
      const self = this;
      if (!this.quotation.name) {
        this.$message.error("name is required!");
        return;
      }

      if (!this.quotation.email) {
        this.$message.error("email is required!");
        return;
      }

      if (!this.quotation.businessPhoneNumber) {
        this.$message.error("Phone is required!");
        return;
      }

      if (
        !/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
          this.quotation.email
        )
      ) {
        this.$message.error("Please input a valid email!");
        return;
      }

      this.submmiting = true;
      let params = {
        ...this.quotation,
        productName: this.mouldInfo.name,
        mouldCategory: [this.mouldInfo.categoryName],
      };
      console.log("params", params);
      customFetch(
        `${palFormUrl}/hicPlatform/createHicQuotation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(params),
        },
        () => {
          this.$message.success(
            "Thanks for your inquiry,we'll contact you ASAP."
          );
          this.submmiting = false;
          this.quotation = {};
        },
        () => {
          this.submmiting = false;
          self
            .$confirm(retryTips, "FAILED", {
              confirmButtonText: "Try Again",
              cancelButtonText: "Cancel",
              type: "error",
            })
            .then(() => {
              self.submmit();
            })
            .catch(() => {});
        }
      );
    },
    getAllCategory() {
      let allCatego = JSON.parse(localStorage.allCategories);
      console.log("allCatego");
      if (allCatego.length > 0) {
        allCatego.forEach((item, index) => {
          this.goLevelCate(item, index);
        });
        this.categoryOptions = allCatego;
        return;
      }
      customFetch(
        `${palFormUrl}/international/getInternationalProductsCategoryList`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: 0,
          }),
        },
        (res) => {
          res.result.forEach((item, index) => {
            this.goLevelCate(item, index);
          });
          this.categoryOptions = res.result;
          console.log(this.categoryOptions);
        },
        () => {}
      );
    },
    categoryCascaderChange(item) {
      let obj = this.$refs.categorycascader.getCheckedNodes();
      if (obj.length > 0) {
        this.name = obj[0].label;
        this.categoryId = obj[0].value;
        this.$router.push(
          `/products-list/${this.name
            .split(" ")
            .map((item) => item.toLowerCase())
            .join("-")}/${this.categoryId}`
        );
      }
    },
    goLevelCate(item, index) {
      if (item.internationalProductsCategoryList.length > 0) {
        item.internationalProductsCategoryList.forEach((sub, index) => {
          this.goLevelCate(sub, index);
        });
      } else {
        delete item.internationalProductsCategoryList;
      }
    },
  },
};
</script>
<style lang="scss">
.carimg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  text-align: center;
}
.breadcrumbitem {
  &:hover {
    color: #0084ff;
    cursor: pointer;
  }
}
.introduce {
  line-height: 25px;
  display: inline-block;
  text-align: justify;
}

.qa {
  text-align: left;
  h3 {
    margin: 0;
    padding: 0;
    font-size: 1.3em;
  }
  p {
    margin: 0;
    padding: 0.5rem 0 1.5rem;
  }

  .title {
    font-size: 2rem;
    margin-bottom: 1rem;
  }
}

.moreAbout {
  text-align: left;
  white-space: pre-line;
  h2 {
    margin: 0;
    padding: 0;
    line-height: 40px;
    font-size: 1.3em;
  }
  p {
    margin: 0;
    line-height: 25px;
  }

  strong {
    font-size: 1em;
  }
}
</style>
